<template lang="">
    <div class="content__trajet bg-white shadow">
        <h2 class="text-center m-0 py-3 text-default">
            Lignes de temps du Parcours médical et financier
        </h2>
        <hr class="m-0" />
         
        <div class="px-md-4 py-4">
            <div class="row justify-content-center px-md-6">
                <div class="col-12 col-md-6 col-lg mr-md-2 d-flex align-items-center border-primary border rounded px-2">
                    <input type="text" class="form-control border-0" 
                    placeholder="recherchez par date....." 
                    v-model="searchDate"></input>
                    <i class="fa fa-calendar" aria-hidden="true"></i>
                </div>
                <div class="col-12 col-md-6 col-lg my-2 my-md-0 d-flex align-items-center border-primary border rounded px-2">
                    <input type="text" class="form-control border-0" 
                    placeholder="Rechercher par motif de ligne de temps....." 
                    v-model="searchTrajet"></input>
                    <i class="fa fa-search" aria-hidden="true"></i>
                </div>
            </div>
            <div class="px-md-6 py-4 content__scroll">
                <div class="trajet__box" v-for="(ligne_temp, index) in filterTrajet" 
                :key="index" @click="changeColor(index)" v-model="motif">
                    <div v-b-toggle="'collapse'+index" :class="{ 'trajet__active' : selectTrajet }"
                    class="trajet__info mt-2 px-2 px-md-4 d-flex justify-content-between align-items-center"
                   >
                        <div class="trajet__info--text d-flex align-items-center fs-6">
                            <i class="fa fa-calendar text-primary" aria-hidden="true"></i>
                            <span class="text-primary px-1">{{ formattedDateTime(ligne_temp.created_at) }}</span>
                            <span class="px-2 d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                            <span class="text-default">{{ ligne_temp.motif }}</span>
                        </div>
                        <div class="d-flex state_valid">
                            <li class="trajet__info--state ama" :class="ligne_temp.cloture_ama ? 'bg-primary' : 'bg-secondary'"></li>
                            <li class="trajet__info--state" :class="ligne_temp.cloture_gestionnaire ? 'bg-info' : 'bg-secondary'"></li>
                            <li class="trajet__info--state" :class="ligne_temp.cloture_medecin_referent ? 'bg-default' : 'bg-secondary'"></li>
                        </div>
                    </div>
                    <b-collapse :id="'collapse'+index" class="mt-1">
                        <b-card>
                            <div class="py-2">
                                <ul class="trajet__item p-0 px-md-4" v-for="(version, key) in ligne_temp.validations" :key="index+'-'+key">
                                    <li class="d-flex l-none align-items-center">
                                        <span class="text-muted d-none d-md-block"><i class="fa fa-check-circle" aria-hidden="true"></i> ---- </span>
                                        <div class="trajet__item--box mx-2 px-2">
                                            <i class="fa fa-calendar text-primary" aria-hidden="true"></i>
                                            <span class="text-primary px-1">{{ formattedDateTime(version.date) }}</span>
                                            <span class="text-default">
                                                <span class="fw-bold mr-3">{{ version.title }}</span>
                                                <b-button class="border-0 p-0 shadow-none text-primary" v-b-modal="'modal-lg'+version.id"> Voir bilan Financier
                                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                                </b-button> 
                                                <b-modal :id="'modal-lg'+version.id" size="lg" centered :title="'Bilan Médical et Financier version '+version.version" hide-footer>
                                                    <BilanFinancier :id="ligne_temp.id" :version="version.version" :acteur="version.acteur" />
                                                </b-modal>
                                            </span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </b-card>
                    </b-collapse>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BilanFinancier from './BilanFinancier.vue'
import axios from 'axios';
import AppConfig from "../../constants/AppConfig";
import Multiselect from 'vue-multiselect'
import moment from "moment";

import  search  from "@/_services/trajetService";
export default {
    name: "TrajetFinancier",
    components: {
        BilanFinancier, Multiselect
    },
    computed: {},
    props: ['dossier_medical_slug'],
     data() {
      return {
        ligne_temps: [],
        unique_ligne_temps: [],
        trajetActive: false,
        searchTrajet: '',
        searchDate: null,
        isDateVisible: null,
        isVisible: false,
        selectTrajet: null,
        motifs: [],
        date: '',
        motif: '',
        dates: []
      }
  },
    methods: {
      formattedDate(date) {
          if (moment(date).isValid()) {
              return moment(date).format("DD-MM-YYYY");
          } else {
              return date;
          }
      },
      laravelDate(date) {
          if (moment(date).isValid()) {
              return moment(date).format("YYYY-MM-DD");
          } else {
              return date;
          }
      },
      formattedDateTime(date) {
          if (moment(date).isValid() && date != null) {
              return moment(date).format("DD-MM-YYYY");
          } else {
              return date;
          }
      },
      getTrajetFinancier(dossier_medical_slug){
        axios.get(`${AppConfig.apiUrl}/ligne-temps/dossier/${dossier_medical_slug}`, {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }})
        .then(res => {
        res.data.ligne_temps.filter(item => item.validations.length > 0);
        let ligne_temps = [];
        res.data.ligne_temps.forEach(i => {
            if(i.validations.length > 0)
            {
                let histories = [], validations = [];
                i.validations.forEach(validation => {
                    if(validation.histories != null){
                        validation.histories.forEach(history => {
                            let data = JSON.parse(history.changes);
                            if(data.length != 0 && data.version){
                            histories.push(data);
                            }
                        })
                    }
                })
                histories = [...new Map(histories.map(item => [item['version']['after'], item])).values()];
               
                histories.forEach(history => {
                    validations.push({
                    id:i.id+history.version.after+"financiere",
                    acteur: "assureur",
                    date: history.updated_at.after,
                    ligne: i.ligne_de_temps_id,
                    version: history.version.after,
                    type: "validation",
                    title: "Validation financière  version "+ history.version.after+ " du "+ this.formattedDateTime(history.updated_at.after),
                    detail: i.validations
                    });
                });
                ligne_temps.push({
                    id: i.id,
                    motif: i.motif.description,
                    created_at: this.formattedDateTime(i.created_at),
                    validations: validations,
                    cloture_ama: i.cloture.ama,
                    cloture_gestionnaire : i.cloture.gestionnaire,
                    cloture_medecin_referent: i.cloture.medecin_referent,
                })
          
            }       
        })
        this.ligne_temps = ligne_temps;
        })
        .catch((error) => {
            console.log("error ", error)
        });
      },
      changeColor: function(event) {
        event.target.classList.add('trajet__active');
    },
    selectTrajets(ligne_temp){
        this.selectTrajet = ligne_temp;
    },
  },
  mounted() {
    this.getTrajetFinancier(this.dossier_medical_slug);
  },
  computed: {
    filterTrajet(){    
       return search(this.searchTrajet, this.searchDate, this.ligne_temps, this.ligne_temp)
    },
  }

}


</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
</style>